import type { AchievementPersistentEffects } from "@/features/achievements/achievementEffects";
import { DEFAULT_UPGRADE_REPEAT_INITIAL_INTERVAL_MS } from "@/features/hoverIdle/upgrades/upgradeRepeatTiming";

type HovGainFamilyRepeatTimingEffects = Pick<
  AchievementPersistentEffects,
  | "hovGainFamilyUpgradeRepeatInitialIntervalMs"
  | "amplifierUpgradeRepeatInitialIntervalMs"
>;

export interface GameUpgradeRepeatInitialIntervals {
  readonly hovGainFamilyUpgrade: () => number;
  readonly amplifierUpgrade: () => number;
  readonly defaultUpgrade: () => number;
}

export function createGameUpgradeRepeatInitialIntervals(
  getAchievementPersistentEffects: () => HovGainFamilyRepeatTimingEffects,
): GameUpgradeRepeatInitialIntervals {
  return {
    hovGainFamilyUpgrade: () =>
      getAchievementPersistentEffects()
        .hovGainFamilyUpgradeRepeatInitialIntervalMs,
    amplifierUpgrade: () =>
      getAchievementPersistentEffects().amplifierUpgradeRepeatInitialIntervalMs,
    defaultUpgrade: () => DEFAULT_UPGRADE_REPEAT_INITIAL_INTERVAL_MS,
  };
}
